import {goBack} from '~/routing/actions'
import {backend, Environment} from '@eitje/api'
import {ModalWithNewForm, Message, EitjeButton, Select} from '~/components'
import {FileField} from './file_field'

export const ImportUsers = () => {
	const environments = Environment.useAll()

	const handleSubmit = ({environment_id, excel}) => {
		const formData = new FormData()
		formData.append('excel', excel)
		return backend.post(`/environments/${environment_id}/import_users`, formData, {
			headers: {'Content-Type': 'multipart/form-data'},
		})
	}

	return (
		<ModalWithNewForm
			name="user_import"
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			modalProps={{
				t: 'modals.user_import.title',
				okButtonProps: {
					t: 'common.import',
					iconLeft: 'download',
				},
				buttons: <EitjeButton iconLeft="download" t="common.example_file" externalLink="/files/eitje_example_user_import.xlsx" />,
			}}
			width={400}
		>
			<Message t={'modals.user_import.message'} />
			<Select required field="environment_id" labelField="naam" items={environments} />
			<FileField required field="excel" />
		</ModalWithNewForm>
	)
}
